import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';
import md5 from 'crypto-js/md5';

import fields from '../../lib/fields';

import FormFields from '../../components/form/fields';
import ImageScroller from '../../components/imagescroller';
import HelpText from '../../components/gui/helpText';
import Input from '../../components/form/input';
import GuiList from '../../components/gui/list';
import UserProfileInline from '../../components/user/profileInline';
import Camera from '../../components/gui/camera';

import localUtil from '../../lib/util';
import { QRCodeSVG } from 'qrcode.react';

function generateArray(X) {
    const myNewShinyArray = [...Array(parseInt(X, 10) + 1).keys()];
    myNewShinyArray.shift();
    return myNewShinyArray;
}

class ConventionViewResults extends Component {
  	constructor(props) {
        super(props);
        this.state = {
        };
    }

    isFieldShooting = (type) => {
        const isFieldShooting = ['norgesfelt', 'felt', 't-96'].includes(type);
        return isFieldShooting;
    }

    getResultsListForAllClasses = (convention, results) => {
        const { conventionResultStore, conventionStore } = this.props.stores;
        const { participants: allParticipants } = conventionStore;
        // console.log('getResultsListForAllClasses', convention, results);
        const allResults = {};

        if (!convention || !convention.stages || !convention.stages.length) {
            return allResults;
        }

        const { stageStands = [] } = convention;
        const norgesFeltTargetMaxValues = conventionResultStore.getNorgesfeltTargetMaxValues();

        convention.stages.forEach((stage, idx) => {
            const isFieldShooting = this.isFieldShooting(stage.type);
            const participants = convention[`participants${idx + 1}`];
            const stands = generateArray(stage.stages || 10);
            const fields = conventionResultStore.getParticipantFields(stage);
            // .map((field, index) => {
            //     const targetResult = participantResults.find(result => result.targetIndex === index);
            //     if (targetResult) {
            //         totalScore += targetResult.scoreTotal;
            //     }

            if (participants && participants.length) {
                participants.forEach(participant => {
                    const participantResults = results.filter(result => result.participant === participant.id && result.stage === stage.md5);
                    let totalScore = 0;
                    let totalIx = 0;
                    let standScore = 0;
                    let maxHits = 0;
                    let maxTargets = 0;
                    let maxInner = 0;

                    const className = participant.class || 'Ingen klasse';
                    if (!allResults[className]) {
                        allResults[className] = {
                            className,
                            participants: [],
                        };
                    }

                    const currentParticipant = allParticipants.find(p => p.id === participant.id);
                    allResults[className].participants.push({
                        id: participant.id,
                        name: localUtil.displayName(participant),
                        sportsClub: currentParticipant ? currentParticipant.sportsClub || 'Mangler klubb' : 'n/a',
                        nsfId: currentParticipant ? currentParticipant.nsfId : null,
                        rubicId: currentParticipant ? currentParticipant.rubicId : null,
                        nsfDiciplineClasses: currentParticipant ? currentParticipant.nsfDiciplineClasses : [],
                        isYou: participant.id === this.props.stores.userStore.user.id,
                        totalScore: 0,
                        totalIx: 0,
                        results: [],
                    });
                    const participantResult = allResults[className].participants[allResults[className].participants.length - 1];

                    if (isFieldShooting) {
                        stands.forEach(stand => {
                            standScore = 0;
                            const targetResult = participantResults.find(result => result.stand === stand);
                            standScore += targetResult?.scoreHits || 0;
                            standScore += targetResult?.scoreTargets || 0;
                            if (targetResult?.scorePenalty) {
                                standScore -= targetResult.scorePenalty;
                            }
                            totalScore += standScore;
                            totalIx += targetResult?.scoreInner || 0;
                            participantResult.results.push({
                                stand,
                                scoreHits: targetResult?.scoreHits || 0,
                                scoreTargets: targetResult?.scoreTargets || 0,
                                scorePenalty: targetResult?.scorePenalty || 0,
                                scoreInner: targetResult?.scoreInner || 0,
                                scoreTotal: standScore,
                            });

                            const currentStand = parseInt(stand, 10);
                            let currentMaxValues = {};
                            if (stage.type === 'norgesfelt') {
                                currentMaxValues = norgesFeltTargetMaxValues.find(item => item.stand === currentStand);
                            } else if (stage.type === 'felt') {
                                currentMaxValues = stageStands.find(item => parseInt(item.stand, 10) === currentStand);
                            }
                            let standMaxHits = parseInt(currentMaxValues?.scoreHits, 10) || 6;
                            let standMaxTargets = parseInt(currentMaxValues?.scoreTargets, 10) || 6;
                            let standMaxInner = parseInt(currentMaxValues?.scoreInner, 10) || 6;
                            maxHits += standMaxHits;
                            maxTargets += standMaxTargets;
                            maxInner += standMaxInner;
                        });
                    } else {
                        fields.forEach((field, index) => {
                            const targetResult = participantResults.find(result => result.targetIndex === index);
                            // console.log('targetResult', targetResult);
                            standScore = parseInt(targetResult?.scoreTotal || 0, 10);
                            totalScore += standScore;
                            participantResult.results.push({
                                stand: index,
                                scoreHits: 0,
                                scoreTargets: 0,
                                scorePenalty: 0,
                                scoreInner: 0,
                                scoreTotal: standScore,
                            });
                        });
                    }
                    participantResult.totalScore = totalScore;
                    participantResult.totalIx = totalIx;
                    // console.log('totalScore', totalScore, 'maxHits', maxHits, 'maxTargets', maxTargets);
                    participantResult.rankingScore = (totalScore / (maxHits + maxTargets) * 100).toFixed(1);

                    allResults[className].participants[allResults[className].participants.length - 1] = participantResult;
                    allResults[className].participants.sort(localUtil.fieldSorter(['-totalScore', '-totalIx']));
                });
            }
        });

        return allResults;
    }

    calculateScore = (hits, targets, penalty) => {
        let score = parseInt(hits || 0, 10) + parseInt(targets || 0, 10);
        if (penalty) {
            score -= parseInt(penalty, 10);
        }
        return score;
    }

    calculateSummary = () => {
        const { conventionStore, conventionResultStore } = this.props.stores;
        const { convention, participants: allParticipants } = conventionStore;
        const { conventionResults } = conventionResultStore;

        if (!convention || !conventionResults) {
            return;
        }
        console.log('calculateSummary', conventionResults);
        const resultList = this.getResultsListForAllClasses(convention, conventionResults);
        const allClasses = ['fin', 'grov', 'mil', 'milrp', 'rev', 'revrp', 'sp.pistol', 'sp.rev', 'mag1', 'mag2', 'Ingen klasse'];
        // In each stage count the the number of participants.
        const summary = {
            totalResults: conventionResults.length,
            totalParticipants: conventionStore.participants.length,
            totalNumberOfStarts: convention.stages.reduce((acc, stage) => {
                const participants = convention[`participants${stage.idx}`] || [];
                return acc + participants.length;
            }, 0),
            totalClasses: allClasses.filter(c => resultList[c]).length,
            totalStages: convention.stages.length,
            totalScore: conventionResults.reduce((acc, result) => acc + this.calculateScore(result.scoreHits, result.scoreTargets, result.scorePenalty), 0),
            totalHits: conventionResults.reduce((acc, result) => acc + (result.scoreHits || 0), 0),
            totalIx: conventionResults.reduce((acc, result) => acc + (result.scoreInner || 0), 0),
            totalShotsFired: 0, // This will be calculated based on the class of the participant
            clubRanking: [],
            averageHits: 0,
            averageIx: 0,
        };

        // I want to create a club ranking based on the total score of each club.
        const clubRanking = {};
        conventionResults.forEach(result => {
            const currentParticipant = allParticipants.find(p => p.id === result.participant);
            const participantClub = currentParticipant.sportsClub || 'Ingen klubb';
            if (!clubRanking[participantClub]) {
                clubRanking[participantClub] = {
                    club: participantClub,
                    totalIx: 0,
                    totalHits: 0,
                    averageHits: 0,
                    averageIx: 0,
                    totalShotsFired: 0,
                };
            }
            clubRanking[participantClub].totalHits += result.scoreHits || 0;
            clubRanking[participantClub].totalIx += result.scoreInner || 0;
        });
        conventionResults.forEach(result => {
            const currentParticipant = allParticipants.find(p => p.id === result.participant);
            const participantClub = currentParticipant.sportsClub || 'Ingen klubb';
            if (clubRanking[participantClub]) {
                const participantClass = result.class || 'Ingen klasse';
                const shotsPerParticipant = ['sp.rev', 'sp.pistol'].includes(participantClass) ? 5 : 6;
                clubRanking[participantClub].totalShotsFired += shotsPerParticipant;
                clubRanking[participantClub].averageHits = Math.ceil((clubRanking[participantClub].totalHits / clubRanking[participantClub].totalShotsFired || 0) * 100);
                clubRanking[participantClub].averageIx = Math.ceil((clubRanking[participantClub].totalIx / clubRanking[participantClub].totalShotsFired || 0) * 100);
            }
        });
        // Sort the club ranking by total score and total ix.
        const sortedClubRanking = Object.values(clubRanking).sort((a, b) => {
            if (a.averageHits === b.averageHits) {
                return b.averageIx - a.averageIx; // Sort by total ix if total score is the same
            }
            return b.averageHits - a.averageHits; // Sort by total score
        });
        // Add the club ranking to the summary.
        summary.clubRanking = sortedClubRanking;

        // Calculate the total shots fired based on the class of the participant.
        conventionResults.forEach(result => {
            const participantClass = result.class || 'Ingen klasse';
            const shotsPerParticipant = ['sp.rev', 'sp.pistol'].includes(participantClass) ? 5 : 6;
            summary.totalShotsFired += shotsPerParticipant;
        });

        summary.averageHits = Math.ceil((summary.totalHits / summary.totalShotsFired || 0) * 100);
        summary.averageIx = Math.ceil((summary.totalIx / summary.totalShotsFired || 0) * 100);

        conventionStore.updateKeyValue('summary', summary);
        console.log('calculateSummary', summary);
    }

    componentDidMount() {
        this.calculateSummary();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.conventionId !== this.props.conventionId) {
            this.calculateSummary();
        }
    }

    render() {
        const { isConventionAdmin } = this.props;
        const { appState, userStore, conventionStore, conventionResultStore } = this.props.stores;
        const { user = {}, isAdmin, isCustomerAdmin, isTester, isVeterinary, language, searchUsersResult } = userStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        const { convention, participants, summary = {}, disciplineMap = [], classMap = [] } = conventionStore;
        const { conventionResults } = conventionResultStore;

        const resultList = this.getResultsListForAllClasses(convention, conventionResults);
        const allClasses = ['fin', 'grov', 'mil', 'milrp', 'rev', 'revrp', 'sp.pistol', 'sp.rev', 'mag1', 'mag2', 'Ingen klasse'];
        const apiServer = util.getApiServer();
        const jwtToken = util.getJwtToken();

        return (<>
            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-3'>
                <Text id='convention.results-summary-numbers'>Summary in numbers</Text>
            </div>
            <div class={`d-flex flex-wrap mt-0 mb-0 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} overflow-auto`}>
                <div class='w-100 d-flex flex-column'>
                    <div class='d-flex flex-row justify-content-between'>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalNumberOfStarts}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-starts'>Starts</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalParticipants}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-participants'>Participants</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalClasses}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-classes'>Classes</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalStages}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-stages'>Stages</Text></span>
                        </div>

                    </div>
                    <div class='d-flex flex-row justify-content-between mt-2'>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalShotsFired}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-total-shots-fired'>Shots</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.averageHits}%</span>
                            <span class='font-weight-lighter'><Text id='convention.results-average-hits'>Hits</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.averageIx}%</span>
                            <span class='font-weight-lighter'><Text id='convention.results-average-ix'>IX</Text></span>
                        </div>
                        <div class='d-flex flex-column flex-fill align-items-center bg-light rounded-lg p-2 mr-2'>
                            <span class='font-weight-bold'>{summary.totalIx}</span>
                            <span class='font-weight-lighter'><Text id='convention.results-total-ix'>Total IX</Text></span>
                        </div>
                    </div>
                </div>
                <div class='w-100 d-flex flex-column mt-3'>
                    <div class='table-responsive w-100'>
                        <table class='table table-sm table-striped'>
                            <thead>
                                <tr>
                                    <th class='w-50'><Text id='convention.results-club'>Club</Text></th>
                                    <th class='w-20 text-center'><Text id='convention.results-average-hits'>Hits</Text></th>
                                    <th class='w-20 text-center'><Text id='convention.results-average-ix'>Avg IX</Text></th>
                                    <th class='w-10 text-center'><Text id='convention.results-total-shots-fired'>Shots</Text></th>
                                </tr>
                            </thead>
                            <tbody>
                                {summary.clubRanking?.map((club, idx) => {
                                    return (<>
                                        <tr key={idx}>
                                            <td class='text-left'>{club.club}</td>
                                            <td class='text-center'>{club.averageHits}%</td>
                                            <td class='text-center'>{club.averageIx}%</td>
                                            <td class='text-center'>{club.totalShotsFired}</td>
                                        </tr>
                                    </>);
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>

            <div class='font-weight-lighter px-3 box-header d-flex flex-row justify-content-between mb-1 mt-3'>
                <Text id='convention.results'>Results</Text>
            </div>
            <div class={`d-flex flex-wrap mt-0 mb-3 mx-3 px-3 py-3 rounded-lg ${darkmode ? 'bg-darkmode' : 'bg-lightmode'} overflow-auto`}>
                {/* {JSON.stringify(resultList, null, 4)} */}

                {allClasses.filter(c => resultList[c]).map((className, idx) => {
                    const classResults = resultList[className];
                    const nsfDiscipline = disciplineMap.find(c => c.key === className) || null;
                    return (<>
                        <h5>{className}</h5>
                        <div class='table-responsive w-100'>
                            <table class='table table-sm table-striped'>
                                <thead>
                                    <tr>
                                        <th class='w-5'>#</th>
                                        <th class='w-85'><Text id='convention.results-name'>Name</Text></th>
                                        <th class='w-5'><Text id='convention.results-score'>Score</Text></th>
                                        <th class='w-5'><Text id='convention.results-ix'>Ix</Text></th>
                                        <th class='w-5'><Text id='convention.results-ranking'>Ranking</Text></th>
                                    </tr>
                                </thead>
                                <tbody>
                                {classResults.participants.map((participant, idx) => {
                                    // const participantDisciplineName = disciplineMap.find((d) => d.id === participant.disciplineId)?.name;
                                    const participantClassId = participant.nsfDiciplineClasses?.find(c => c.disciplineId === nsfDiscipline?.id)?.classId || null;
                                    // const nsfClass = classMap.find(d => d.id === participantClassId) || conventionStore.getNsfFallbackClass();
                                    const nsfClass = classMap.find(d => d.id === participantClassId);
                                    // const participantClassName = classMap.find((c) => c.id === participant.classId)?.name;
                                    // console.log('participant', participant)
                                    return (<>
                                        <tr>
                                            <td class='text-center'>{idx + 1}</td>
                                            <td class='text-left'>
                                                {participant.name}
                                                <span class='font-weight-lighter ml-2'>({participant.sportsClub})</span>
                                                {/* <small class='badge badge-secondary font-weight-light ml-2'>
                                                    {nsfDiscipline ? nsfDiscipline.name : 'Ingen disiplin'}
                                                </small> */}
                                                {/* <small class='badge badge-secondary font-weight-light ml-2'>
                                                    {nsfClass ? nsfClass.name : 'Ingen klasse'}
                                                </small> */}
                                                {/* participantDisciplineName: {participantDisciplineName || 'n/a'} */}
                                                {/* nsfDiscipline: {JSON.stringify(nsfDiscipline)} */}
                                                {/* nsfClass: {JSON.stringify(nsfClass)} */}
                                            </td>
                                            <td class='text-center'>{participant.totalScore}</td>
                                            <td class='text-center'>{participant.totalIx}</td>
                                            <td class='text-center'>{participant.rankingScore}%</td>
                                        </tr>
                                    </>);
                                })}
                                </tbody>
                            </table>
                        </div>
                    </>);
                })}
            </div>

        </>);
    }
}
export default ConventionViewResults;
